import React, { FC } from 'react'
import classnames from 'classnames'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { theme } from 'transfix-ui/theme'
import { brandColors } from 'transfix-ui/theme/colors'
import { ShipperFacilityHour } from 'apps/marketplace/apiTypes/shipperFacilities'
import { TDay } from '../../utils/getFacilityHours'
import { Separator } from '../Separator'
import { PreviewDayShifts } from './PreviewDayShifts'

export interface IHourBlockProps {
  hours: ShipperFacilityHour
}

const useStyles = makeStyles({
  day: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  label: {
    width: '3.1875rem',
    color: brandColors.coolGray8,
    marginRight: theme.spacing(1),
  },
  overridden: {
    backgroundColor: brandColors.infoLight,
  },
})

type TDays = { label: string; value: TDay }[]

const days: TDays = [
  { label: 'Mon', value: 'monday' },
  { label: 'Tue', value: 'tuesday' },
  { label: 'Wed', value: 'wednesday' },
  { label: 'Thu', value: 'thursday' },
  { label: 'Fri', value: 'friday' },
  { label: 'Sat', value: 'saturday' },
  { label: 'Sun', value: 'sunday' },
]

const compressedScheduled: TDays = [
  { label: 'Mon-Fri', value: 'monday' },
  { label: 'Sat', value: 'saturday' },
  { label: 'Sun', value: 'sunday' },
]

export const HourBlock: FC<IHourBlockProps> = ({ hours }) => {
  const classes = useStyles()
  const { value = {}, overridden = false } = hours
  if (hours.value?.open247) {
    return (
      <div className={classnames({ [classes.overridden]: overridden })}>
        <Typography variant='subtitle2'>Open 24/7</Typography>
      </div>
    )
  }

  return (
    <div className={classnames({ [classes.overridden]: overridden })}>
      {(value.sameHoursMonFri ? compressedScheduled : days).map(day => {
        return (
          <Box key={day.label} className={classes.day}>
            <Box display='flex'>
              <div className={classes.label}>
                <Typography variant='subtitle2'>{day.label}</Typography>
              </div>
              <PreviewDayShifts shifts={value.shifts?.filter(s => s.day === day.value) || []} />
            </Box>
            {day.label !== 'Sun' && <Separator />}
          </Box>
        )
      })}
    </div>
  )
}
